export const USER_TOKEN = 'token';
export const USER_KEY = 'user';
export const FLOATING_THREADS = 'floatingThreads';
export const NAVBAR_COLLAPSED = 'navbar-collapsed';
export const RELEASE_NOTES_PREFERENCES = 'release-notes-preferences';
